<template>
    <div class="pa-5 ma-3 white rounded-lg">
        <div class="subheading grey--text mb-9">Reservation List</div>

        <v-row>
            <v-col cols="6" offset="6" class="pt-0">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
            </v-col>
        </v-row>
        
        <v-data-table :headers="headers" :items="items" :footer-props="paginationOptions" :search="search"
            item-key="id" :options="pagination" :loading="loading" @click:row="toReservationDetails" @pagination="onPagination">
            <template v-slot:item.wantDate="{ item }">
                {{ formatDate( item.wantDate ) }}
            </template>
            <template v-slot:item.order.foreignId="{ item }">
                <span v-if="item.order == null"></span>
                <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                        <v-btn depressed :to="'/orders/' + item.orderId" text :color="orderStatusColor(item.order.status)" v-if="item.order.foreignId != undefined && item.order.foreignId.length > 0" v-on="on">{{ item.order.foreignId }}</v-btn>
                    </template>
                    <span>{{ item.order.status }}</span>
                </v-tooltip>
            </template>
        </v-data-table>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
    data: () => ({
        headers     : [
            { text: 'Customer', value: 'customer.fullName', sortable: true },
            { text: 'Use Date', value: 'useDate', sortable: true },
            { text: 'Pickup Date', value: 'wantDate', sortable: true },
            { text: 'Return Date', value: 'returnDate', sortable: true },
            { text: 'Order', value: 'order.foreignId', sortable: true },
            // { text: 'Order Status', value: 'order.status', sortable: true },
        ],
        pagination: {
            sortBy: ['date']
        },
        paginationOptions: { itemsPerPageOptions: [ 25, 50, -1 ] },
        loading: false,
        search: '',
    }),
    computed: {
        ...mapGetters({
            items       : 'reservations/reservations',
            hasMore     : 'reservations/hasMore',
            needRefresh : 'reservations/needRefresh'
        }),
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions({
            loadReservations: 'reservations/loadReservations'
        }),
        async init() {
            try {
                if( !this.needRefresh )
                    return; 

                this.loading = true;
                await this.loadReservations();
                this.loading = false;
            }
            catch(error) {
                this.loading = false;
            }
        },
        formatDate(d) {
            return moment(d).format('YYYY-MM-DD @ hh:mm a')
        },
        toReservationDetails(item) {
            this.$router.push(`/reservations/${item.id}`);
        },
        onPagination(v) {
            if( v.pageCount != v.page || this.search != '' ) {
                return;
            }

            this.loadMore();
        },
        async loadMore() {
            try {
                if( !this.hasMore )
                    return;
                
                this.loading = true;
                await this.loadReservations();
                this.loading = false;
            }
            catch(error) {
                this.loading = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>